import React, { Component } from 'react'
import { obtenerDatosUsuario, getAparienciaFirma, subirAparienciaFirma } from './UsuarioService';
import Resizer from "react-image-file-resizer";
import { Cookies } from 'react-cookie';
import { username, idEmpresa, aparienciaFirma, nombreEmpresa } from '../../constans/constants';
import MensajeFlash from '../mensajeFlash/MensajeFlash';
import validarImagen from "../seguridad/ValidadorImagen";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import DropzoneComponent from "../componentes/DropzoneComponent";

class DatosUsuarioModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            datosUsuario: "",
            empresa: "",
            roles: [],
            aparienciaFirma: "",
            uriAparienciaFirma: "",
            isAparienciaNueva: false,
            isErrorAparienciaFirma: false,
            mensajeErrorAparienciaFirma: "",

            mensajeFlash: "",
            mostrarMensajeFlash: false,
            mensajeFlashSeverity: "neutral",
        };
    }

    componentDidMount() {
        let datosUsuario, aparienciaFirma
        obtenerDatosUsuario(username()).then(resp => {
            if (!resp.error) {
                datosUsuario = resp.datos
                getAparienciaFirma(datosUsuario.id).then(resp => {
                    aparienciaFirma = "data:image/png;base64," + resp
                    this.setState({
                        datosUsuario: datosUsuario,
                        empresa: nombreEmpresa(),
                        roles: this.getRolesAsignados(),
                        aparienciaFirma: aparienciaFirma
                    })

                })
            }
        })

    }

    getRolesAsignados = () => {
        let aux = JSON.parse(localStorage.getItem("roles"))
        let roles = []
        aux.roles.map((elemento) => {
            roles.push(elemento.nombre)
        })
        return roles
    }

    handleUploadAparienciaFirma = () => {
        let formData = new FormData()
        formData.append("file", this.state.uriAparienciaFirma)
        subirAparienciaFirma(formData, username())
            .then((resp => {
                this.setState({
                    mostrarMensajeFlash: true,
                    mensajeFlash: resp.mensaje,
                    mensajeFlashSeverity: resp.error ? "error" : "exito",
                })
            }))
    }

    handleChangeAparienciaFirma = async (archivo) => {
        const resultadoAnalisis = await validarImagen(archivo)
        if (resultadoAnalisis.isValid) {
            Resizer.imageFileResizer(
                archivo,
                200, 150,
                "PNG",
                0, 0,
                (uri) => {
                    this.setState({
                        aparienciaFirma: URL.createObjectURL(uri),
                        uriAparienciaFirma: uri,
                        isAparienciaNueva: true,
                    })
                },
                "file",
            )
        } else {
            this.setState({
                mostrarMensajeFlash: true,
                mensajeFlash: resultadoAnalisis.error,
                mensajeFlashSeverity: "error"
            })
        }
    }

    render() {
        return (
            <div>
                <div className="template-base">
                    <header className="component-header">
                        <div className="page-container">
                            <BreadCrumComponent
                                backUrl={'/bandeja/pendientes'}
                                breadcrumbs={
                                    [
                                        { label: 'Menu principal', path: '/bandeja/pendientes' }
                                    ]
                                }
                            />
                            <div className="head-area">
                                <div className="caption-area">
                                    <h1 className="page-title"> Datos de usuario </h1>
                                    <p className="page-description"> Visualice detalles de su cuenta y edite su apariencia de firma</p>
                                </div>
                            </div>
                        </div>
                    </header>
                    <div className="wrapperContent">
                        <div className="page-container card">
                            <div className="component-card-info">
                                <h2 className="card-title"> {this.state.datosUsuario.nombreApellido?.trim() || "--"} </h2>

                                <div className="card__cols">
                                    <div className="content-inner">
                                        <span className="label"> Nombre de usuario </span>
                                        <span className="txt"> {this.state.datosUsuario.usuario?.trim() || "--"} </span>
                                    </div>
                                    <div className="content-inner">
                                        <span className="label"> Nro. IPS Patronal </span>
                                        <span className="txt"> {this.state.datosUsuario.nroPersonalIps?.trim() || "--"} </span>
                                    </div>
                                    <div className="content-inner">
                                        <span className="label"> Nro. Trabajo MTESS </span>
                                        <span className="txt"> {this.state.datosUsuario.nroTrabajoMtess?.trim() || "--"} </span>
                                    </div>
                                    <div className="content-inner">
                                        <span className="label"> Empresa </span>
                                        <span className="txt"> {this.state.empresa?.trim() || "--"} </span>
                                    </div>
                                    <div className="content-inner">
                                        <span className="label"> Cédula de identidad </span>
                                        <span className="txt">{this.state.datosUsuario.cedula?.trim() || "--"}</span>
                                    </div>
                                    <div className="content-inner">
                                        <span className="label"> Teléfono </span>
                                        <span className="txt"> {this.state.datosUsuario.celular?.trim() || "--"} </span>
                                    </div>
                                    <div className="content-inner">
                                        <span className="label"> Identificador </span>
                                        <span className="txt"> {this.state.datosUsuario.identificador?.trim() || "--"} </span>
                                    </div>
                                    <div className="content-inner">
                                        <span className="label"> E-mail </span>
                                        <span className="txt"> {this.state.datosUsuario.email?.trim() || "--"}</span>
                                    </div>
                                </div>

                                <div className="content-inner">
                                    <span className="label"> Roles asignados </span>
                                    <div className="row__labels">
                                        {this.state.roles.map((elemento) => {
                                            return <span key={elemento.id} className="label__info">{elemento}</span>
                                        })}
                                    </div>
                                </div>

                                <hr />

                                <div className="component-carga-apariencia">

                                    <h3 className="form-subtitle"> Apariencia de Firma </h3>
                                    <p className="form-description"> Selecciona el archivo de imagen como apariencia de firma </p>
                                    <div className="container-flex center-content">
                                        {
                                            this.state.aparienciaFirma &&
                                            <div className="col">
                                                <span className="form-midtitle"> Apariencia actual </span>
                                                <div className="signature-area">
                                                    <img id="aparienciaFirmaImg" src={this.state.aparienciaFirma} className="img-fluid" alt="apariencia_firma_actual" />
                                                </div>
                                            </div>
                                        }
                                        <div className="col">
                                            <span className="form-midtitle"> Seleccionar imagen para apariencia de firma </span>
                                            <div className="carga-documento-section">

                                                <div className="carga-documento-content">
                                                    <DropzoneComponent onFileSelected={this.handleChangeAparienciaFirma} archivos_soportados={[".png", ".jpg"]} />
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    {
                                        this.state.isAparienciaNueva &&
                                        <div className="form-actions">
                                            <button onClick={this.handleUploadAparienciaFirma} className="btn-medium btn-primary"> Guardar Apariencia </button>
                                        </div>
                                    }

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <MensajeFlash
                    visible={this.state.mostrarMensajeFlash}
                    mensaje={this.state.mensajeFlash}
                    severity={this.state.mensajeFlashSeverity} />
            </div>

        )
    }
}

export default DatosUsuarioModal;
